module.exports = __webpack_public_path__ + "static/media/23.7ac5e4c9.svg";